import { ShopPage } from "@/features/shop";
import type { RouteConfig } from "@/router/types";

export const SHOP_PATH = "/boutique";

const shopRoutes: RouteConfig[] = [
  {
    path: SHOP_PATH,
    element: <ShopPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default shopRoutes;
